const getDefaultJitaiGroupAssignmentSetting = () => {
  return {
    next_stage_group_assignment_rule: null,
    assigned_group: null,
  }
}

export default getDefaultJitaiGroupAssignmentSetting
